<template>
  <div>
    <v-navigation-drawer
      app
      color="primary"
      permanent
      dark
      mini-variant
      mini-variant-width="82"
    >
      <v-list>
        <v-list-item>
          <v-list-item-content class="mx-auto mt-2 mb-5">
            <img src="@/assets/mini-logo.svg" />
          </v-list-item-content>
        </v-list-item>

        <authorizationTwo permissionKey="receptionist_queue" can="read">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link to="/filas/recepcao" v-bind="attrs" v-on="on">
                <v-list-item-icon>
                  <v-icon>ri-calendar-2-line</v-icon>
                </v-list-item-icon>

                <v-list-item-content> Recepção </v-list-item-content>
              </v-list-item>
            </template>

            <span>Recepção</span>
          </v-tooltip>
        </authorizationTwo>


        <authorizationTwo
          :permissionKey="[
            'island_identification_queue',
            'island_pre_exam_queue',
            'island_dilation_queue',
            'island_therapy_queue',
          ]"
          can="read"
        >
          <v-menu offset-x nudge-right="10" right>
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip right>
                <template v-slot:activator="{ on: tooltip }">
                  <v-list-item v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                    <v-list-item-icon>
                      <v-icon>ri-nurse-line</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content> Ilhas </v-list-item-content>
                  </v-list-item>
                </template>

                <span>Ilhas</span>
              </v-tooltip>
            </template>

            <DefaultLayoutAttendancePlaceList
              :attendance-places="nursingOfClinicAttendancePlaces"
              base-path="/filas/enfermagem"
            />
          </v-menu>
        </authorizationTwo>

        <authorizationTwo permissionKey="doctor_queue" can="read">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link to="/filas/medico" v-bind="attrs" v-on="on">
                <v-list-item-icon>
                  <v-icon>ri-stethoscope-line</v-icon>
                </v-list-item-icon>

                <v-list-item-content> Médico </v-list-item-content>
              </v-list-item>
            </template>

            <span>Médico</span>
          </v-tooltip>
        </authorizationTwo>

        <authorizationTwo permissionKey="authorization_queue" can="read">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                link
                to="/filas/autorizacao"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-icon>
                  <v-icon>eva-credit-card-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content> Autorização </v-list-item-content>
              </v-list-item>
            </template>

            <span>Autorização</span>
          </v-tooltip>
        </authorizationTwo>

        <authorizationTwo permissionKey="exams_queue" can="read">
          <v-menu offset-x nudge-right="10" right>
            <template
              v-slot:activator="{ on: menuListeners, attrs: menuAttrs }"
            >
              <v-tooltip right>
                <template v-slot:activator="{ on: tooltipListeners }">
                  <v-list-item
                    v-bind="menuAttrs"
                    v-on="{ ...tooltipListeners, ...menuListeners }"
                  >
                    <v-list-item-icon>
                      <v-icon>ri-flask-line</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content> Exames </v-list-item-content>
                  </v-list-item>
                </template>

                <span>Exames</span>
              </v-tooltip>
            </template>

            <DefaultLayoutAttendancePlaceList
              :attendance-places="examsAttendancePlaces"
              base-path="/filas/exames"
            />
          </v-menu>
        </authorizationTwo>

        <authorizationTwo permissionKey="contact_lens_test_queue" can="read">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                link
                to="/filas/lente-contato"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-icon>
                  <v-icon>eva-eye-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content> Lente de contato </v-list-item-content>
              </v-list-item>
            </template>

            <span>Lente de contato</span>
          </v-tooltip>
        </authorizationTwo>

        <authorizationTwo
          :permissionKey="[
            'surgery_ward_reception_queue',
            'surgery_ward_preoperative_queue',
            'surgery_ward_intraoperative_queue',
            'surgery_ward_postoperative_queue',
          ]"
          can="read"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                :to="`/filas/bloco-cirurgico`"
                :attrs="attrs"
                v-on="on"
              >
                <v-list-item-icon>
                  <v-icon>ri-hospital-line</v-icon>
                </v-list-item-icon>

                <v-list-item-content> Bloco Cirúrgico </v-list-item-content>
              </v-list-item>
            </template>

            <span>Bloco Cirúrgico</span>
          </v-tooltip>
        </authorizationTwo>

        <authorizationTwo permissionKey="authorization_queue" can="read">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                link
                to="/filas/planejamento-cirurgico"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-icon>
                  <v-icon>ri-calendar-check-line</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Planejamento Cirúrgico
                </v-list-item-content>
              </v-list-item>
            </template>

            <span>Planejamento Cirúrgico</span>
          </v-tooltip>
        </authorizationTwo>

        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link to="/atendimentos" v-bind="attrs" v-on="on">
              <v-list-item-icon>
                <v-icon>ri-map-pin-user-line</v-icon>
              </v-list-item-icon>

              <v-list-item-content> Atendimentos </v-list-item-content>
            </v-list-item>
          </template>

          <span>Atendimentos </span>
        </v-tooltip>

        <authorizationTwo permissionKey="patient_search" can="read">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link to="/pacientes" v-bind="attrs" v-on="on">
                <v-list-item-icon>
                  <v-icon>eva-search-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content> Busca de pacientes </v-list-item-content>
              </v-list-item>
            </template>

            <span>Busca de pacientes</span>
          </v-tooltip>
        </authorizationTwo>
      </v-list>

      <template v-slot:append>
        <v-list>
          <authorizationTwo permissionKey="attendance_medical_record" can="read">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item link to="/configuracoes" v-bind="attrs" v-on="on">
                  <v-list-item-icon>
                    <v-icon>eva-settings-2-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content> Configurações </v-list-item-content>
                </v-list-item>
              </template>

              <span>Configurações</span>
            </v-tooltip>
          </authorizationTwo>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar color="white" flat app>
      <v-row dense align="center">
        <v-spacer></v-spacer>

        <v-col cols="auto" class="font-weight-bold">
          {{ employeeName }}
        </v-col>

        <v-col cols="auto">
          <v-menu offset-y bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-on="on" :attrs="attrs">
                <v-avatar size="40" color="gray lighten-2">
                  <v-icon color="white">eva-person-outline</v-icon>
                </v-avatar>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="logout">
                <v-list-item-title> Logout </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-app-bar>

    <transition name="slide-fade">
      <v-container fluid>
        <v-row>
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
// disable e-sign
// import Vue from "vue";
// import Lacuna from "@/plugins/lacuna";
//  created() {
//    Vue.use(Lacuna);
//  }

import DefaultLayoutAttendancePlaceList from "@/views/layouts/default/attendance_place_list.vue";
import GET_ATTENDANCE_PLACES from "@/graphql/attendance_place/attendance_places.gql";

export default {
  name: "DefaultLayout",
  components: { DefaultLayoutAttendancePlaceList },
  created() {
   // Vue.use(Lacuna);
  },
  apollo: {
    nursingOfClinicAttendancePlaces: {
      query: GET_ATTENDANCE_PLACES,
      update: (data) => data.attendancePlaces,
      variables: {
        attendancePlaceCategory: "nursing_of_clinic",
        // add variable para filtrar attendance by-Unit
      },
    },
    examsAttendancePlaces: {
      query: GET_ATTENDANCE_PLACES,
      update: (data) => data.attendancePlaces,
      variables: {
        attendancePlaceCategory: "exams",
        // add variable para filtrar attendance by-Unit
      },
    },
  },
  computed: {
    employeeName() {
      if (this.$store.state.authentication?.user?.employee?.name) {
        return this.$store.state.authentication.user.employee.name;
      }

      return "";
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("authentication/signOut").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
